import React, { Component } from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    Grid,
    Typography,
    Link,
} from "@mui/material";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { applications } from "./ApiCommonService";
import { GetBrokerApplicationsById } from "../ApiSevices/QuoteCompareAPI";
import SvgIcon from '@mui/material/SvgIcon';
import { fetchComplianceData } from "../ApiSevices/UserMasterApis";
import { jwtDecode } from "jwt-decode";

interface IProps {
    onAppSelect: (
        applicationId: number,
        complianceFlag: number
    ) => void;

    allowedMenus: string[];

    onComplianceSelect: (
        complianceFlag: number
    ) => void;
}

interface IAppSwitchState {
    loading: boolean;
    apps: any[];
    selectedPolicyOption:
    | "commercial"
    | "endorsement"
    | "personal"
    | null;
    currentUser: string;
    showPersonalLine: boolean;
    isRoUser: boolean;
    complianceData: any[];
}

const FlipIcon = (props: any) => (
    <SvgIcon {...props} viewBox="0 0 64 64">
        <path
            d="
        M18 31
        L29 22
        L29 26
        C37 26 43 22 43 16
        L43 11
        C48 14 51 18 51 23
        C51 33 43 38 30 38
        L30 43
        L18 35
        Z
      "
        />
    </SvgIcon>
);

export default class AppSwitch extends Component<IProps, IAppSwitchState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            loading: true,
            apps: [],
            selectedPolicyOption: null,
            showPersonalLine: false,
            isRoUser: false,
            complianceData: [],
            currentUser: "",
        };
    }

    selectedComplianceFlag = (flag: string) => {
        switch (flag) {
            case "commercial":
                this.props.onComplianceSelect(1);
                break;
            case "endorsement":
                this.props.onComplianceSelect(2);
                break;
            case "personal":
                this.props.onComplianceSelect(3);
                break;
            default:
                this.props.onComplianceSelect(0);
                break;
        }
    }

    onApplicationSelect = (applicationId: number) => {
        let complianceFlag = 0;

        switch (this.state.selectedPolicyOption) {
            case "commercial":
                complianceFlag = 1;
                break;

            case "endorsement":
                complianceFlag = 2;
                break;

            case "personal":
                complianceFlag = 3;
                break;

            default:
                complianceFlag = 0;
                break;
        }

        this.props.onComplianceSelect(complianceFlag);

        this.props.onAppSelect(
            applicationId,
            complianceFlag
        );
    };

    componentDidMount(): void {
        this.fetchApplications();
    }

    fetchApplications = async () => {
        this.setState({ loading: true });

        try {
            const [applications, complianceData] = await Promise.all([
                GetBrokerApplicationsById(),
                fetchComplianceData()
            ]);

            this.filterCompliancedata(complianceData);
            this.setState({
                apps: applications || []
            });
        } catch (error) {
            console.error("Error fetching applications:", error);
        } finally {
            this.setState({ loading: false });
        }
    };

    filterCompliancedata = (complianceData: any[]) => {
        let sessionToken = sessionStorage.getItem("token");
        const decodedSessionToken: any = sessionToken ? jwtDecode(sessionToken) : null;
        const brokerId = decodedSessionToken?.BrokerId?.toString();
        const RoleId = decodedSessionToken?.RoleId;
        const email = decodedSessionToken?.Email;
        let result: any[] = [];
        if (brokerId === "0") {
            result = complianceData?.filter(e => e.Broker === "0" || (e?.RoleId?.includes(RoleId) || e.UserId.includes(email)))?.map(e => e.Menu);
        } else {
            result = complianceData?.filter(e => e?.Broker?.includes(brokerId) || (e?.RoleId?.includes(RoleId) || e.UserId.includes(email)))?.map(e => e.Menu);
        }
        if (result.length === 0 && (email === "istudio_admin@exdioninsurance.com" || email === "istudio_supervisor@exdioninsurance.com" || email === "Msuser_upload@exdioninsurance.com")) {
            result.push("Commercial Line");
        }
        this.setState({ complianceData: result, currentUser: email, isRoUser: decodedSessionToken?.IsRoUser });
    }

    // Select Commercial Line or Endorsement Checking
    selectPolicyOption = (
        option: "commercial" | "endorsement" | "personal"
    ) => {
        this.setState({
            selectedPolicyOption: option,
        });
    };

    showPersonalLineView = () => {
        this.setState({
            showPersonalLine: true,
            selectedPolicyOption: null,
        });
    };

    showDefaultPolicyView = () => {
        this.setState({
            showPersonalLine: false,
            selectedPolicyOption: null,
        });
    };

    goBackToPolicyOptions = () => {
        this.setState({
            selectedPolicyOption: null,
        });
    };

    // NORMAL APPLICATION CARD
    renderCard = (
        title: string,
        heading: string,
        description: React.ReactNode,
        logoUrl: string | undefined,
        applicationId: number
    ) => (
        <Card
            sx={{
                height: "370px",
                minHeight: "370px",
                display: "flex",
                flexDirection: "column",
                borderRadius: "6px",
                border: "1px solid #e0e0e0",
                overflow: "hidden",
                boxSizing: "border-box",
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    backgroundColor: "#007bff",
                    color: "#fff",
                    textAlign: "center",
                    py: 1,
                    fontWeight: 600,
                    fontSize: "17px",
                    minHeight: "54px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxSizing: "border-box",
                }}
            >
                {title}
            </Box>

            <CardContent
                sx={{
                    flex: 1,
                    padding: "14px 18px 0px !important",
                }}
            >
                <Grid container spacing={1}>
                    {/* Heading + Logo */}
                    <Grid item xs={12}>
                        <Grid container alignItems="center">
                            <Grid item xs>
                                <Typography
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: "16px",
                                        lineHeight: 1.3,
                                        mb: 0.5,
                                    }}
                                >
                                    {heading}
                                </Typography>
                            </Grid>

                            <Grid item>
                                {logoUrl && (
                                    <img
                                        src={logoUrl}
                                        alt={title}
                                        style={{
                                            height: 40,
                                            width: "auto",
                                            border: "1px solid #dee2e6",
                                        }}
                                    />
                                )}
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* Description */}
                    <Grid item xs={12}>
                        <Typography
                            sx={{
                                fontSize: "13px",
                                lineHeight: 1.45,
                                color: "#333",
                            }}
                        >
                            {description}
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>

            {/* Footer Button */}
            <Box sx={{ px: 2, pb: 1.5 }}>
                <Button
                    fullWidth
                    variant="contained"
                    sx={{
                        backgroundColor: "#2b2f6c",
                        textTransform: "none",
                        height: "40px",
                        fontSize: "14px",
                        "&:hover": {
                            backgroundColor: "#24285d",
                        },
                    }}
                    disabled={
                        title === "Quote Compare"
                            ? !this.state.apps.includes(title)
                            : false
                    }
                    onClick={() =>
                        this.onApplicationSelect(applicationId)
                    }
                >
                    {title === "Quote Compare"
                        ? this.state.apps.includes(title)
                            ? "Take me there"
                            : "Please contact support to subscribe"
                        : "Take me there"}
                </Button>
            </Box>
        </Card>
    );

    // POLICY CHECK CARD
    renderPolicyCheckCard = (
        title: string,
        heading: string,
        description: React.ReactNode,
        logoUrl: string | undefined,
        applicationId: number,
        cardCount: number
    ) => {
        const {
            selectedPolicyOption,
            showPersonalLine,
            complianceData,
            currentUser
        } = this.state;

        const cardTabLength = complianceData.length;
        const isCommercial =
            selectedPolicyOption === "commercial";

        const isEndorsement =
            selectedPolicyOption === "endorsement";

        const isPersonal =
            selectedPolicyOption === "personal";

        // =====================================
        // EXPANDED COMMERCIAL VIEW
        // =====================================
        if (isCommercial) {
            return (
                <Card
                    sx={{
                        height: "370px",
                        minHeight: "370px",
                        display: "flex",
                        flexDirection: "column",
                        borderRadius: "6px",
                        border: "1px solid #e0e0e0",
                        overflow: "hidden",
                        boxSizing: "border-box",
                    }}
                >
                    <Box
                        sx={{
                            backgroundColor: "#007bff",
                            color: "#fff",
                            textAlign: "center",
                            py: 1,
                            fontWeight: 600,
                            fontSize: "17px",
                            minHeight: "54px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxSizing: "border-box",
                            position: "relative",
                        }}
                    >
                        <ArrowBackIcon
                            onClick={this.goBackToPolicyOptions}
                            sx={{
                                position: "absolute",
                                left: "18px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                            }}
                        />

                        Policy Check – Commercial Line
                    </Box>

                    <CardContent
                        sx={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            gap: 3,
                        }}
                    >
                        <Box
                            sx={{
                                width: 90,
                                height: 90,
                                borderRadius: "20px",
                                backgroundColor: "#e8f1fc",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexShrink: 0,
                            }}
                        >
                            <DescriptionOutlinedIcon
                                sx={{
                                    fontSize: 52,
                                    color: "#1976d2",
                                }}
                            />
                        </Box>

                        <Box>
                            <Typography
                                sx={{
                                    fontWeight: 600,
                                    fontSize: "18px",
                                    mb: 1,
                                }}
                            >
                                Policy Check – Commercial Line
                            </Typography>

                            {/* <Typography
                                sx={{
                                    fontSize: "14px",
                                    color: "#333",
                                }}
                            >
                                Validates Commercial polices against the lob specific rules.
                            </Typography> */}
                        </Box>
                    </CardContent>

                    <Box sx={{ px: 2, pb: 2 }}>
                        <Button
                            fullWidth
                            variant="contained"
                            sx={{
                                backgroundColor: "#2b2f6c",
                                textTransform: "none",
                                "&:hover": {
                                    backgroundColor: "#24285d",
                                },
                            }}
                            onClick={() =>
                                this.onApplicationSelect(applicationId)
                            }
                        >
                            Take me to Commercial Line
                        </Button>
                    </Box>
                </Card>
            );
        }

        // =====================================
        // EXPANDED ENDORSEMENT VIEW
        // =====================================
        if (isEndorsement) {
            return (
                <Card
                    sx={{
                        height: "370px",
                        minHeight: "370px",
                        display: "flex",
                        flexDirection: "column",
                        borderRadius: "6px",
                        border: "1px solid #e0e0e0",
                        overflow: "hidden",
                        boxSizing: "border-box",
                    }}
                >
                    <Box
                        sx={{
                            backgroundColor: "#007bff",
                            color: "#fff",
                            textAlign: "center",
                            py: 1,
                            fontWeight: 600,
                            fontSize: "17px",
                            minHeight: "54px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxSizing: "border-box",
                            position: "relative",
                        }}
                    >
                        <ArrowBackIcon
                            onClick={this.goBackToPolicyOptions}
                            sx={{
                                position: "absolute",
                                left: "18px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                            }}
                        />

                        Endorsement Checking
                    </Box>

                    <CardContent
                        sx={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            gap: 3,
                        }}
                    >
                        <Box
                            sx={{
                                width: 90,
                                height: 90,
                                borderRadius: "20px",
                                backgroundColor: "#f0eafa",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexShrink: 0,
                            }}
                        >
                            <FactCheckOutlinedIcon
                                sx={{
                                    fontSize: 52,
                                    color: "#6b4aa5",
                                }}
                            />
                        </Box>

                        <Box>
                            <Typography
                                sx={{
                                    fontWeight: 600,
                                    fontSize: "18px",
                                    mb: 1,
                                }}
                            >
                                Endorsement Checking
                            </Typography>

                            {/* <Typography
                                sx={{
                                    fontSize: "14px",
                                    color: "#333",
                                }}
                            >
                                Verify Endorsements on Commercial Policies.
                            </Typography> */}
                        </Box>
                    </CardContent>

                    <Box sx={{ px: 2, pb: 2 }}>
                        <Button
                            fullWidth
                            variant="contained"
                            sx={{
                                backgroundColor: "#2b2f6c",
                                textTransform: "none",
                                "&:hover": {
                                    backgroundColor: "#24285d",
                                },
                            }}
                            onClick={() =>
                                this.onApplicationSelect(applicationId)
                            }
                        >
                            Take me to Endorsement Checking
                        </Button>
                    </Box>
                </Card>
            );
        }

        // =====================================
        // EXPANDED PERSONAL LINE VIEW
        // =====================================
        if (isPersonal) {
            return (
                <Card
                    sx={{
                        height: "370px",
                        minHeight: "370px",
                        display: "flex",
                        flexDirection: "column",
                        borderRadius: "6px",
                        border: "1px solid #e0e0e0",
                        overflow: "hidden",
                        boxSizing: "border-box",
                    }}
                >
                    <Box
                        sx={{
                            backgroundColor: "#007bff",
                            color: "#fff",
                            textAlign: "center",
                            py: 1,
                            fontWeight: 600,
                            fontSize: "17px",
                            minHeight: "54px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxSizing: "border-box",
                            position: "relative",
                        }}
                    >
                        <ArrowBackIcon
                            onClick={this.goBackToPolicyOptions}
                            sx={{
                                position: "absolute",
                                left: "18px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                            }}
                        />

                        Policy Check – Personal Line
                    </Box>

                    <CardContent
                        sx={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            gap: 3,
                        }}
                    >
                        <Box
                            sx={{
                                width: 90,
                                height: 90,
                                borderRadius: "20px",
                                backgroundColor: "#e7f5ec",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexShrink: 0,
                            }}
                        >
                            <DescriptionOutlinedIcon
                                sx={{
                                    fontSize: 52,
                                    color: "#2e8b57",
                                }}
                            />
                        </Box>

                        <Box>
                            <Typography
                                sx={{
                                    fontWeight: 600,
                                    fontSize: "18px",
                                    mb: 1,
                                }}
                            >
                                Policy Check – Personal Line
                            </Typography>

                            {/* <Typography
                                sx={{
                                    fontSize: "14px",
                                    color: "#333",
                                }}
                            >
                                Validates Personal polices against the lob specific rules.
                            </Typography> */}
                        </Box>
                    </CardContent>

                    <Box sx={{ px: 2, pb: 2 }}>
                        <Button
                            fullWidth
                            variant="contained"
                            sx={{
                                backgroundColor: "#2b2f6c",
                                textTransform: "none",
                                "&:hover": {
                                    backgroundColor: "#24285d",
                                },
                            }}
                            onClick={() =>
                                this.onApplicationSelect(applicationId)
                            }
                        >
                            Take me to Personal Line
                        </Button>
                    </Box>
                </Card>
            );
        }

        // =====================================
        // 3D FLIP CARD
        // =====================================
        // =====================================
        // DEFAULT POLICY OPTIONS VIEW
        // =====================================
        return (
            <Card
                sx={{
                    height: "370px",
                    minHeight: "370px",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "6px",
                    border: "1px solid #e0e0e0",
                    overflow: "hidden",
                    boxSizing: "border-box",
                }}
            >
                {/* HEADER */}
                <Box
                    sx={{
                        backgroundColor: "#007bff",
                        color: "#fff",
                        textAlign: "center",
                        py: 1,
                        fontWeight: 600,
                        fontSize: "17px",
                        minHeight: "54px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxSizing: "border-box",
                        position: "relative",
                    }}
                >
                    {title}
                </Box>

                <CardContent
                    sx={{
                        flex: 1,
                        padding: "12px 18px !important",
                        boxSizing: "border-box",
                    }}
                >
                    {/* HEADING + LOGO */}
                    <Grid
                        container
                        alignItems="center"
                        sx={{ mb: cardTabLength === 1 ? 3 : 1 }}
                    >
                        <Grid item xs>
                            <Typography
                                sx={{
                                    fontWeight: 600,
                                    fontSize: "16px",
                                    lineHeight: 1.3,
                                }}
                            >
                                {heading}
                            </Typography>
                        </Grid>

                        <Grid item>
                            {logoUrl && (
                                <img
                                    src={logoUrl}
                                    alt={title}
                                    style={{
                                        height: 40,
                                        width: "auto",
                                        border: "1px solid #dee2e6",
                                    }}
                                />
                            )}
                        </Grid>
                    </Grid>

                    {/* DESCRIPTION */}
                    <Typography
                        sx={{
                            fontSize: "12.5px",
                            lineHeight: 1.4,
                            color: "#333",
                            // mb: 1.2,
                            marginBottom: cardTabLength <= 2 ? "30.6px" : "9.6px",
                        }}
                    >
                        {description}
                    </Typography>

                    {/* ================================= */}
                    {/* COMMERCIAL LINE */}
                    {/* ================================= */}
                    {(complianceData.includes("Commercial Line") || currentUser === "istudio_admin@exdioninsurance.com") &&
                        <Box
                            onClick={(event) => {
                                event.stopPropagation();
                                this.selectPolicyOption("commercial");
                            }}
                            sx={{
                                width: "100%",
                                minHeight: "56px",
                                height: "56px",
                                display: "flex",
                                alignItems: "center",
                                gap: 1.2,
                                p: 1,
                                mb: 1,
                                border: "1px solid #ddd",
                                borderRadius: "8px",
                                backgroundColor: "#fff",
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                                boxSizing: "border-box",

                                "&:hover": {
                                    transform: "translateY(-1px)",
                                    boxShadow:
                                        "0px 3px 10px rgba(0,0,0,0.12)",
                                },
                            }}
                        >
                            {/* ICON */}
                            <Box
                                sx={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: "10px",
                                    backgroundColor: "#e8f1fc",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexShrink: 0,
                                }}
                            >
                                <DescriptionOutlinedIcon
                                    sx={{
                                        fontSize: 28,
                                        color: "#1976d2",
                                    }}
                                />
                            </Box>

                            {/* TEXT */}
                            <Box
                                sx={{
                                    flex: 1,
                                    minWidth: 0,
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: "13.5px",
                                        fontWeight: 600,
                                        lineHeight: 1.2,
                                    }}
                                >
                                    Policy Check – Commercial Line
                                </Typography>

                                {/* <Typography
                                    sx={{
                                        fontSize: "11px",
                                        mt: 0.2,
                                        lineHeight: 1.2,
                                        color: "#666",
                                    }}
                                >
                                    Validates commercial policies against LOB-specific rules.
                                </Typography> */}
                            </Box>

                            {/* ARROW */}
                            <Typography
                                sx={{
                                    fontSize: "20px",
                                    color: "#777",
                                    flexShrink: 0,
                                }}
                            >
                                →
                            </Typography>
                        </Box>
                    }

                    {/* ================================= */}
                    {/* ENDORSEMENT CHECKING */}
                    {/* ================================= */}
                    {(complianceData.includes("Endorsement Checking") || currentUser === "istudio_admin@exdioninsurance.com") &&
                        <Box
                            onClick={(event) => {
                                event.stopPropagation();
                                this.selectPolicyOption("endorsement");
                            }}
                            sx={{
                                width: "100%",
                                minHeight: "56px",
                                height: "56px",
                                display: "flex",
                                alignItems: "center",
                                gap: 1.2,
                                p: 1,
                                mb: 1,
                                border: "1px solid #ddd",
                                borderRadius: "8px",
                                backgroundColor: "#fff",
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                                boxSizing: "border-box",

                                "&:hover": {
                                    transform: "translateY(-1px)",
                                    boxShadow:
                                        "0px 3px 10px rgba(0,0,0,0.12)",
                                },
                            }}
                        >
                            {/* ICON */}
                            <Box
                                sx={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: "10px",
                                    backgroundColor: "#f0eafa",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexShrink: 0,
                                }}
                            >
                                <FactCheckOutlinedIcon
                                    sx={{
                                        fontSize: 28,
                                        color: "#6b4aa5",
                                    }}
                                />
                            </Box>

                            {/* TEXT */}
                            <Box
                                sx={{
                                    flex: 1,
                                    minWidth: 0,
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: "13.5px",
                                        fontWeight: 600,
                                        lineHeight: 1.2,
                                    }}
                                >
                                    Endorsement Checking
                                </Typography>

                                {/* <Typography
                                    sx={{
                                        fontSize: "11px",
                                        mt: 0.2,
                                        lineHeight: 1.2,
                                        color: "#666",
                                    }}
                                >
                                    Verify endorsements on commercial policies.
                                </Typography> */}
                            </Box>

                            {/* ARROW */}
                            <Typography
                                sx={{
                                    fontSize: "20px",
                                    color: "#777",
                                    flexShrink: 0,
                                }}
                            >
                                →
                            </Typography>
                        </Box>}

                    {/* ================================= */}
                    {/* PERSONAL LINE */}
                    {/* ================================= */}
                    {(complianceData.includes("Personal Line") || currentUser === "istudio_admin@exdioninsurance.com") &&
                        <Box
                            onClick={(event) => {
                                event.stopPropagation();
                                this.selectPolicyOption("personal");
                            }}
                            sx={{
                                width: "100%",
                                height: "56px",
                                minHeight: "56px",
                                display: "flex",
                                alignItems: "center",
                                gap: 1.2,
                                p: 1,
                                mb: 1,
                                border: "1px solid #ddd",
                                borderRadius: "8px",
                                backgroundColor: "#fff",
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                                boxSizing: "border-box",

                                "&:hover": {
                                    transform: "translateY(-1px)",
                                    boxShadow:
                                        "0px 3px 10px rgba(0,0,0,0.12)",
                                },
                            }}
                        >
                            {/* ICON */}
                            <Box
                                sx={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: "10px",
                                    backgroundColor: "#e7f5ec",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexShrink: 0,
                                }}
                            >
                                <DescriptionOutlinedIcon
                                    sx={{
                                        fontSize: 28,
                                        color: "#2e8b57",
                                    }}
                                />
                            </Box>

                            {/* TEXT */}
                            <Box
                                sx={{
                                    flex: 1,
                                    minWidth: 0,
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: "13.5px",
                                        fontWeight: 600,
                                        lineHeight: 1.2,
                                    }}
                                >
                                    Policy Check – Personal Line
                                </Typography>

                                {/* <Typography
                                    sx={{
                                        fontSize: "11px",
                                        mt: 0.2,
                                        lineHeight: 1.2,
                                        color: "#666",
                                    }}
                                >
                                    Validates personal policies against LOB-specific rules.
                                </Typography> */}
                            </Box>

                            {/* ARROW */}
                            <Typography
                                sx={{
                                    fontSize: "20px",
                                    color: "#777",
                                    flexShrink: 0,
                                }}
                            >
                                →
                            </Typography>
                        </Box>}
                </CardContent>
            </Card>
        );
    };

    render() {
        const { loading, complianceData, currentUser, isRoUser } = this.state;
        const isRoUserCheck = isRoUser || false;

        const year = new Date().getFullYear();

        const hasUserMaster = this.props?.allowedMenus?.includes("UserMaster") || isRoUserCheck === true;

        let applist = applications;
        if(currentUser && currentUser !== null) {
            if (complianceData.length === 0 && (currentUser !== "istudio_admin@exdioninsurance.com" && currentUser !== "istudio_supervisor@exdioninsurance.com" && currentUser !== "Msuser_upload@exdioninsurance.com")) {
                applist = applist.filter(app => app.applicationId !== 1);
            }
        }

        const filteredApplications = hasUserMaster
            ? applist
            : applist.filter(
                app => app.applicationId !== 3
            );


        return (
            <>
                {/* LOADING */}
                {loading && (
                    <Box
                        sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor:
                                "rgba(255, 255, 255, 0.5)",
                            zIndex: 9999,
                        }}
                    >
                        <div className="loader"></div>
                    </Box>
                )}

                {/* MAIN CONTENT */}
                {!loading && (
                    <Box
                        sx={{
                            minHeight: "100vh",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        {/* PAGE CONTENT */}
                        <Box
                            sx={{
                                flex: 1,
                                px: 3,
                                pt: "65px",
                            }}
                        >
                            <Typography className="card-header" style={{ textAlign: filteredApplications.length === 1 ? "center" : "left",  paddingTop: filteredApplications.length === 1 ? "10px" : undefined,paddingBottom: filteredApplications.length === 1 ? "20px" : undefined, }}>
                                Exdion lStudio Suite
                            </Typography>

                            {/* APPLICATION CARDS */}
                            <Box
                                sx={{
                                    overflowY: "auto",
                                    height: "70vh",
                                }}
                            >
                                <div className="app-grid"
                                    style={{
                                            gridTemplateColumns:
                                                filteredApplications.length === 1
                                                    ? "60%"
                                                    : filteredApplications.length === 2
                                                        ? "49% 49%"
                                                        : "repeat(3, 1fr)",

                                            justifyContent:
                                                filteredApplications.length <= 2
                                                    ? "center"
                                                    : undefined,

                                            gap: "20px",
                                        }}
                                >

                                    {filteredApplications.map(
                                        (card) => (
                                            <div
                                                key={
                                                    card.applicationId
                                                }
                                            >
                                                {/* POLICY CHECK */}
                                                {
                                                    card.title ===
                                                        "Policy Check" ? (
                                                        this.renderPolicyCheckCard(
                                                            card.title,
                                                            card.heading,
                                                            card.description,
                                                            card.logo,
                                                            card.applicationId || 0,
                                                            filteredApplications.length,
                                                        )
                                                    ) : (
                                                        /* OTHER APPLICATIONS */
                                                        this.renderCard(
                                                            card.title,
                                                            card.heading,
                                                            card.description,
                                                            card.logo,
                                                            card.applicationId ||
                                                            0
                                                        )
                                                    )
                                                }
                                            </div>
                                        )
                                    )}

                                </div>
                            </Box>
                        </Box>

                        {/* FOOTER */}
                        <Box
                            sx={{
                                borderTop:
                                    "1px solid #e0e0e0",
                                display: "flex",
                                justifyContent:
                                    "space-between",
                                alignItems: "center",
                                backgroundColor: "#fff",
                                px: 2,
                            }}
                        >
                            <img
                                src="logos/Exdion iSTUDIO Logo.jpg"
                                alt="Exdion Edge"
                                style={{
                                    height: "52px",
                                    padding: "4px",
                                }}
                            />

                            <Typography
                                sx={{
                                    fontSize: "13px",
                                    color: "#555",
                                }}
                            >
                                © {year} - Exdion Edge -{" "}
                                <Link
                                    href="https://exdionedge.app/helpfiles/PrivacyPolicy.pdf"
                                    underline="hover"
                                >
                                    Privacy
                                </Link>
                            </Typography>
                        </Box>
                    </Box>
                )}
            </>
        );
    }
}